import { BackgroundCheckPackageDto } from '@clh/api-client';

export const MANUAL_VERIFICATION_OPTION = 'MANUAL_VERIFICATION';
export const MANUAL_VERIFICATION_LABEL = 'Manually Verified Background Check';

export type ProviderFilter = 'ALL' | 'CHECKR' | 'KARMACHECK';

const KARMACHECK_EMPTY_OPTION = {
    label: 'No KarmaCheck options yet. Click Sync Packages to load them.',
    value: 'KARMACHECK_EMPTY',
    disabled: true,
};

type PackageOption = { label: string; value: string; disabled?: boolean };
type PackageOptionGroup = { label: string; options: PackageOption[] };

function toOptions(
    packages: BackgroundCheckPackageDto[],
    provider: BackgroundCheckPackageDto['provider']
): PackageOption[] {
    const byName = new Map<string, PackageOption>();

    for (const pkg of packages) {
        if (pkg.provider === provider && !byName.has(pkg.name)) {
            byName.set(pkg.name, { label: pkg.name, value: pkg.id });
        }
    }

    return [...byName.values()];
}

export function packageOptions(
    packages: BackgroundCheckPackageDto[],
    filter: ProviderFilter
): (PackageOption | PackageOptionGroup)[] {
    const checkr = { label: 'Checkr', options: toOptions(packages, 'CHECKR') };
    const karmaCheckOptions = toOptions(packages, 'KARMACHECK');
    const karmaCheck = {
        label: 'KarmaCheck',
        options:
            karmaCheckOptions.length > 0
                ? karmaCheckOptions
                : [KARMACHECK_EMPTY_OPTION],
    };

    switch (filter) {
        case 'CHECKR':
            return [checkr];
        case 'KARMACHECK':
            return [karmaCheck];
        case 'ALL':
            return [
                checkr,
                karmaCheck,
                {
                    label: MANUAL_VERIFICATION_LABEL,
                    value: MANUAL_VERIFICATION_OPTION,
                },
            ];
    }
}
